import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import { Switch } from '@/components/switch';
import { Type } from '@/components/toast';
import { useToasts } from '@/contexts/toast-context';
import {
  useUserContext,
  useUserSettingsContext,
} from '@/contexts/user-context';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  salesRepMode?: boolean;
}

export const TrainingModeSwitch: React.FC<Props> = ({
  containerStyle,
  salesRepMode,
}) => {
  const [styles, theme] = useStyles();
  const { inInboundTrainingMode, setInInboundTrainingMode } =
    useUserSettingsContext();
  const { smartOrderSettings } = useUserContext();
  const { showToast } = useToasts();

  if (!smartOrderSettings?.training_mode_enabled) {
    return null;
  }

  return (
    <View style={[styles.container, containerStyle]}>
      <Text
        style={[
          TYPOGRAPHY.small,
          styles.label,
          salesRepMode ? styles.labelDark : styles.labelLight,
        ]}
      >
        {i18n.t('training_mode')}
      </Text>
      <Switch
        activeTrackColor={
          salesRepMode ? undefined : theme.sk.color.icon.primary
        }
        onValueChange={(nextValue) => {
          setInInboundTrainingMode(nextValue);
          if (nextValue) {
            showToast({
              containerStyle: styles.toastContainer,
              content: i18n.t('training_mode_enabled'),
              type: Type.PRIMARY,
            });
          }
        }}
        testID="training-mode-switch"
        trackingData={{
          name: 'training_mode_switch',
          properties: {
            nextValue: !inInboundTrainingMode,
          },
        }}
        value={inInboundTrainingMode}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 16,
  },
  label: {
    ...FONTS.primarySemiBold,
    color: theme.sk.color.text.secondary,
    lineHeight: 20,
  },
  labelDark: {
    color: theme.sk.color.text.ondark,
  },
  labelLight: {
    color: theme.sk.color.text.primary,
  },
  toastContainer: {
    width: 'auto',
  },
}));
